<template>
  <div>
    <v-card>
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subtitle-1">
            <span v-if="count !== 0">{{ count }} </span>
            <span>{{ $t("pageHeader.comment") }}</span>
          </h1>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-layout class="pt-2 pl-2 pr-2" align-start="align-start" justify-center row>
          <v-avatar size="40px">
            <img v-if="currentUser.imageUrl" :src="currentUser.imageUrl" alt="User" />
            <img v-else src="../../../assets/images/user.jpeg" alt="User" />
          </v-avatar>
          <v-layout class="ml-2 mr-2" column>
            <v-flex>
              <v-textarea
                class="mt-0 pt-0"
                v-model="comment"
                placeholder="Add a comment...."
                auto-grow
                hide-details
                rows="1"
              >
              </v-textarea>
            </v-flex>
            <v-flex class="pt-0 text-right" v-if="comment">
              <v-btn text @click="cancel">cancel</v-btn>
              <v-btn color="info" @click="saveComment">comment</v-btn>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-text>
      <v-card-text>
        <v-progress-linear v-if="loading" size="70" width="7" indeterminate="indeterminate">
        </v-progress-linear>
        <v-layout column v-if="!loading">
          <template v-for="(row, index) in comments">
            <v-layout class="pointer" column>
              <v-container grid-list-lg>
                <v-layout row>
                  <v-avatar size="35px">
                    <img v-if="row.User && row.User.imageUrl" :src="row.User.imageUrl" alt="User" />
                    <img v-else src="../../../assets/images/user.jpeg" alt="User" />
                  </v-avatar>
                  <v-flex class="ml-2">
                    <v-layout column>
                      <div>
                        <span class="body-2 font-weight-medium">{{ row.User.fullName }}</span>
                        <span class="ml-1 body-1 grey--text">{{
                          row.createDateTime | moment("from", "now")
                        }}</span>
                      </div>
                      <div class="font-weight-regular">
                        <span>{{ row.comment }}</span>
                      </div>
                      <div>
                        <v-btn class="grey--text" text small right @click="reply(row)">
                          <v-icon>reply</v-icon>reply</v-btn
                        >
                      </div>
                      <div v-if="row.Comments.length !== 0">
                        <v-expansion-panel
                          class="elevation-0"
                          v-model="panel[row.commentID]"
                          expand="expand"
                        >
                          <v-expansion-panel-content hide-actions="hide-actions">
                            <template v-slot:header>
                              <div class="font-weight-regular">
                                {{ panelName(row)
                                }}<v-icon v-if="panel[row.commentID] && panel[row.commentID][0]"
                                  >keyboard_arrow_up</v-icon
                                >
                                <v-icon v-else>keyboard_arrow_down</v-icon>
                              </div>
                            </template>
                            <v-card color="grey lighten-4">
                              <v-card-text>
                                <template v-for="(item, index) in row.Comments">
                                  <v-layout column>
                                    <v-container grid-list-lg>
                                      <v-layout row>
                                        <v-avatar size="25px">
                                          <img
                                            v-if="item.User && item.User.imageUrl"
                                            :src="item.User.imageUrl"
                                            alt="User"
                                          />
                                          <img
                                            v-else
                                            src="../../../assets/images/user.jpeg"
                                            alt="User"
                                          />
                                        </v-avatar>
                                        <v-flex class="ml-2">
                                          <v-layout column>
                                            <div>
                                              <span class="body-2 font-weight-medium">{{
                                                item.User.fullName
                                              }}</span>
                                              <span class="ml-1 body-1 grey--text">{{
                                                item.createDateTime | moment("from", "now")
                                              }}</span>
                                            </div>
                                            <div class="font-weight-regular">
                                              <span>{{ item.comment }}</span>
                                            </div>
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>
                                    </v-container>
                                  </v-layout>
                                </template>
                              </v-card-text>
                            </v-card>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </div>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-layout>
          </template>
        </v-layout>
      </v-card-text>
      <v-card-text class="pt-0" v-if="loadedData !== count">
        <v-btn text block="block" @click="getMoreData">load more</v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import commentService from "../service.js";
import { mapGetters } from "vuex";

export default {
  props: ["refID", "typeId"],
  data() {
    return {
      headers: [
        {
          text: this.$t("labels.createdAt"),
          value: "createDateTime",
          sortable: true,
          width: "10%"
        },
        {
          text: this.$t("labels.userName"),
          value: "userName",
          sortable: true,
          width: "10%"
        },
        {
          text: this.$t("labels.comment"),
          value: "comment",
          sortable: true
        }
      ],
      limit: 10,
      count: 0,
      loadedData: 0,
      panel: {},
      comment: null,
      comments: [],
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: "createDateTime",
        descending: true
      }
    };
  },
  computed: {
    ...mapGetters("global", ["currentUser"])
  },
  created() {
    this.getList();
  },
  watch: {
    refID() {
      this.getList();
    }
  },
  methods: {
    panelName(val) {
      let commentLength = val.Comments.length;
      let name = null;
      if (commentLength > 1) {
        name = `View ${commentLength} replies`;
      } else {
        name = "View reply";
      }

      if (this.panel[val.commentID] && this.panel[val.commentID][0]) {
        return "Hide replies";
      }
      {
        return name;
      }
    },
    cancel() {
      this.comment = null;
    },
    saveComment() {
      let data = {
        storeID: this.refID,
        referenceID: this.refID,
        typeID: this.typeId,
        comment: this.comment
      };
      return commentService.create(data).then(result => {
        this.comment = null;
        this.getList();
      });
    },
    async reply(comment) {
      const { value: text } = await this.$swal.fire({
        title: "New Comment",
        text: comment.comment,
        input: "textarea",
        inputPlaceholder: "Type your message here...",
        showCancelButton: true
      });
      if (text) {
        let data = {
          storeID: this.refID,
          referenceID: this.refID,
          typeID: this.typeId,
          comment: text,
          displayRelationID: comment.commentID
        };
        return commentService.create(data).then(result => {
          this.getList();
          this.$emit("commentCreated", text);
        });
      }
    },
    getMoreData() {
      this.limit += 10;
      this.getList();
    },
    getList() {
      return commentService
        .getCommentByID({ typeId: this.typeId, id: this.refID, limit: this.limit })
        .then(response => {
          console.log("response", response);
          this.comments = response.data.rows;
          this.loadedData = response.data.rows.length;
          this.count = response.data.count;
          this.loading = false;
          return response;
        });
    }
  }
};
</script>

<style scoped></style>
